import { toolCardRegistry } from "@/lib/toolCardRegistry";

export type ToolPresentationBehavior =
  | "action-request"
  | "independent-interaction"
  | "read-only";

const actionRequestToolNames = new Set<string>([
  ...Object.values(toolCardRegistry).map(({ wireToolName }) => wireToolName),
  // Composite transcript tools that render one of the catalog-backed selection requests above.
  "assumption_discovery",
  "experiment_design",
]);

const independentInteractionToolNames = new Set<string>([
  "proposeAssumptionFieldEdit",
  "proposeHypothesisFieldEdit",
  "proposeExperimentFieldEdit",
]);

const readOnlyToolNames = new Set<string>([
  "workflow_navigation",
  "link_preview",
  "experiment_planner",
]);

/** Presentation behavior only; workflow eligibility and domain mutation remain server-owned. */
export function toolPresentationBehavior(
  toolName: string,
): ToolPresentationBehavior | undefined {
  if (actionRequestToolNames.has(toolName)) return "action-request";
  if (independentInteractionToolNames.has(toolName)) {
    return "independent-interaction";
  }
  if (readOnlyToolNames.has(toolName)) return "read-only";
  return undefined;
}

/** Whether a transcript tool part represents an unresolved durable Action Request. */
export function requiresActionRequestSubmission(toolName: string): boolean {
  return toolPresentationBehavior(toolName) === "action-request";
}

